import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { fetchApi, JsonResponse } from '../../services/api';
import LoadingPanel from '../LoadingPanel';
import { Button } from '@progress/kendo-react-buttons';
import { Input } from '@progress/kendo-react-inputs';
import { DropDownList } from '@progress/kendo-react-dropdowns';
const DocumentTitle = require('react-document-title');

type Props = RouteComponentProps<{}>;

type State = {
    isLoading: boolean;

    TenantName: string;
    DisplayName: string;
    FirstName: string;
    LastName: string;
    Email: string;
    TenantType: number;
}

export default class TenantCreate extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);

        this.state = {
            isLoading: false,

            TenantName: '',
            DisplayName: '',
            FirstName: '',
            LastName: '',
            Email: '',
            TenantType: 0,
        };

        this.create = this.create.bind(this);
        this.onCompanyNameChange = this.onCompanyNameChange.bind(this);
    }

    public render() {
        const businessType = [{ ID: 0, Name: "Daycare" }, { ID: 1, Name: "Tutor"}];
        return <div className="k-form">
            <DocumentTitle title={this.state.DisplayName || "Sign Up"} />
            {this.state.isLoading && <LoadingPanel />}
            <h2>Sign Up</h2>
            <label className="k-form-field">
                <span>Company Name<span style={{ color: '#dc3545' }}>*</span></span>
                <Input
                    type="text"
                    placeholder="Company Name"
                    value={this.state.DisplayName}
                    onChange={(e) => this.onCompanyNameChange(e.target.value)}
                />
            </label>
            <hr />
            <label className="k-form-field">
                <span>Your First Name<span style={{ color: '#dc3545' }}>*</span></span>
                <Input
                    type="text"
                    placeholder="First Name"
                    value={this.state.FirstName}
                    onChange={(e) => this.setState({ FirstName: e.target.value })}
                />
            </label>
            <label className="k-form-field">
                <span>Your Last Name<span style={{ color: '#dc3545' }}>*</span></span>
                <Input
                    type="text"
                    placeholder="First Name"
                    value={this.state.LastName}
                    onChange={(e) => this.setState({ LastName: e.target.value })}
                />
            </label>
            <label className="k-form-field">
                <span>Your Company Email<span style={{ color: '#dc3545' }}>*</span></span>
                <Input
                    type="email"
                    placeholder="Email"
                    value={this.state.Email}
                    onChange={(e) => this.setState({ Email: e.target.value })}
                />
            </label>
            <div className="form-group">
                <label>Business Type</label>
                <DropDownList
                    data={businessType}
                    textField="Name"
                    value={businessType[0]}
                    onChange={(e) => this.setState({ TenantType: e.target.value.ID }) }
                />
            </div>
            <div className="text-right">
                <Button onClick={this.create} primary>Sign Up</Button>
            </div>
        </div>;
    }

    public onCompanyNameChange(DisplayName: string) {
        const TenantName = DisplayName.replace(/[\W_]+/g, "").toLowerCase();
        this.setState({ DisplayName, TenantName });
    }
    
    private create() {
        this.setState({ isLoading: true });
        const data = {
            TenantName: this.state.TenantName,
            DisplayName: this.state.DisplayName,
            FirstName: this.state.FirstName,
            LastName: this.state.LastName,
            Email: this.state.Email,
            TenantType: this.state.TenantType,
        };
        fetchApi('api/Tenant/Create', data, 'POST')
            .then((response: JsonResponse) => {
                this.setState({ isLoading: false });
                if (response.Success)
                {
                    alert('Success! - Please check your email for the password.');
                    window.location.href = `https://${this.state.TenantName}.daycarium.com/`;
                }
                else
                {
                    alert(`Error: ${response.ErrorMessage}`);
                }
            });
    }
}
